import { DocumentSnapshot, DocumentReference } from "firebase/firestore";
import SecureatSnapshot from "./SecureatSnapshot";
import * as ImageKit from "@/utils/ImageUtils";

export default class Distributor extends SecureatSnapshot {
  active: boolean = false;
  address: string = "";
  postal_code: number = 0;
  city: string = "";
  countries: string[] = [];
  name: string = "";
  logo: string | null;
  databases: DocumentReference[];
  shop_email: string | null = null;
  billing_cycle: number = 1;
  phone: string | null = null;
  email: string | null = null;
  secureat_licence_price: number | null = null;

  constructor(
    ref: DocumentReference,
    active: boolean,
    address: string,
    postal_code: number,
    city: string,
    countries: string[],
    name: string,
    logo: string | null,
    databases: DocumentReference[],
    shop_email: string | null = null,
    billing_cycle: number = 1,
    phone: string | null = null,
    email: string | null = null,
    secureat_licence_price: number | null = null
  ) {
    super(ref);
    this.active = active;
    this.address = address;
    this.postal_code = postal_code;
    this.city = city;
    this.countries = countries;
    this.name = name;
    this.logo = logo;
    this.databases = databases;
    this.shop_email = shop_email;
    this.billing_cycle = billing_cycle;
    this.phone = phone;
    this.email = email;
    this.secureat_licence_price = secureat_licence_price;
  }

  public static fromFirestore(snapshot: DocumentSnapshot): Distributor {
    const data = snapshot.data()!;

    let result = new Distributor(
      snapshot.ref,
      data.active,
      data.address,
      data.postal_code,
      data.city,
      data.countries,
      data.name,
      data.logo,
      data.databases != undefined ? data.databases : [],
      data.shop_email != undefined ? data.shop_email : null,
      data.billing_cycle != undefined ? data.billing_cycle : null,
      data.phone != undefined ? data.phone : null,
      data.email != undefined ? data.email : null,
      data.secureat_licence_price != undefined ? data.secureat_licence_price : null,
    );

    return result;
  }

  public toFirestore() {
    return {
      active: this.active,
      address: this.address,
      postal_code: this.postal_code,
      city: this.city,
      countries: this.countries,
      name: this.name,
      logo: this.logo,
      databases: this.databases,
      shop_email: this.shop_email,
      billing_cycle: this.billing_cycle,
      phone: this.phone,
      email: this.email,
    };
  }

  public getBillingCycle(): number {
    return this.billing_cycle != null ? this.billing_cycle : 1;
  }

  public static clone(d: Distributor): Distributor {
    return new Distributor(
      d.ref,
      d.active,
      d.address,
      d.postal_code,
      d.city,
      d.countries.map((x) => x),
      d.name,
      d.logo,
      d.databases,
      d.shop_email,
      d.billing_cycle,
      d.phone,
      d.email,
      d.secureat_licence_price
    );
  }
}
